import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card w-100" }
const _hoisted_3 = { class: "mx-3 pt-4 text-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "rounded-circle icon-circle mx-auto mb-3" }, [
          _createElementVNode("i", { class: "fas fa-chalkboard-teacher mx-auto" })
        ], -1)),
        (_ctx.training_session.training_session_type_id == _ctx.TrainingSessionType.SCENARIO)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, "Scenario Training"))
          : (_ctx.training_session.training_session_type_id == _ctx.TrainingSessionType.ONBOARDING)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_5, "On-Boarding"))
            : (_ctx.training_session.training_session_type_id == _ctx.TrainingSessionType.GROUPED || _ctx.training_session.training_session_type_id == _ctx.TrainingSessionType.LARGEGROUP)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_6, "On-Boarding & Scenario Training"))
              : _createCommentVNode("", true),
        _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "hr-dark" }, null, -1))
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mx-5" }, null, -1))
    ])
  ]))
}